export const manager = {
  seo: {
    title: 'Manage your restaurant online with Bistroo Manager | Bistroo',
    description: 'Manage menus, opening hours, promotions and payments from one app. The Bistroo Manager for restaurants & hospitality businesses.',
  },
  hero: {
    title: {
      pt1: 'An',
      pt2: 'online manager',
      pt3: 'to keep complete control in your own hands',
    },
    description:
      'With the Bistroo Manager app you can adjust everything in your webshop in just a few seconds. Process every order effortlessly and always be the chef of your online restaurant.',
    button: 'Discover the Manager',
  },
  paragraphs: {
    paragraph_1: {
      title: 'Real-time control over your online store',
      text: 'Maintain the perfect customer experience. Adjust all your settings in real time via the Bistroo Manager. Accessible on all your devices, from any location.',
      cta: 'Explore the Bistroo packages',
    },
    paragraph_2: {
      title: 'Perfect delivery settings',
      text: 'Fine-tune your delivery areas to match your daily capacity and draw your desired zones precisely on Google Maps. With the ability to customize your terms per delivery area.',
      cta: '',
    },
    paragraph_3: {
      title: 'Insights & Reporting',
      text: 'Advanced insights and reports are available via the Manager app. Adjust your settings based on data-driven decisions and suggestions from the Manager.',
      cta: 'Explore the Bistroo packages',
    },
    paragraph_4: {
      title: 'Streamline your processes',
      text: 'Save valuable time and manual work, without ever being caught off guard by too many orders or unexpected online traffic! Easily adjust your peak-time volume and estimated delivery times with a single tap. Stay in control at all times.',
      cta: '',
    },
  },
  key_features: {
    cards: {
      card_1: {
        title: 'Easily adjust your menu and settings.',
        text: 'Update your restaurant\'s menu and settings from any location. Access from any device, at any time, and easily change products, prices, inventory, discounts, promotions and delivery areas.',
        button: '',
        img_alt: '',
      },
      card_2: {
        title: 'Integrations.',
        text: 'Connect your favorite POS system or external tools.',
        button: '',
        img_alt: '',
      },
      card_3: {
        title: 'Manage multiple locations.',
        text: 'Easily manage multiple locations, if applicable to your business.',
        button: '',
        img_alt: '',
      },
      card_4: {
        title: 'Track your payments.',
        text: 'Or process refunds. The average refund rate is only 0.2%.',
        button: '',
        img_alt: '',
      },
      card_5: {
        title: 'Reporting & Analytics.',
        text: 'Analyze your online performance with basic and advanced reporting options.',
        button: '',
        img_alt: '',
      },
    },
  },
  testimonial: {
    text: '"The Manager keeps getting updated — it\'s great to see the developments and be part of it."',
    cta: 'Read the full story',
    name: 'Istanbul Grillroom',
    job_title: 'Grillroom',
  },
  faq: {
    title_pt1: 'All about the',
    title_pt2: 'Bistroo Manager',
    items: [
      { q: 'What is the Bistroo Manager app?', a: 'The Bistroo Manager is the central management tool for your online restaurant. Use it to update your menu, manage orders, configure delivery areas, view reports and keep track of everything — from any device.' },
      { q: 'Which devices does the Manager app work on?', a: 'The Manager app works on smartphone, tablet and desktop via the browser. You have access everywhere as long as you have an internet connection — handy even when you are away from the restaurant.' },
      { q: 'How do I update my menu via the Manager?', a: 'Go to the menu section in the Manager, select a product or category and update the price, description, photo or availability. The change goes live immediately on your webshop, kiosk and QR shop.' },
      { q: 'Can I manage multiple locations from one account?', a: 'Yes. Via the Manager you manage multiple venues from a single dashboard. Per location you configure separate menus, opening hours and delivery areas.' },
      { q: 'How do I set up delivery areas and costs?', a: 'Draw your delivery areas precisely on Google Maps in the Manager. Per zone you set delivery costs, minimum order amounts and availability. Changes take effect immediately.' },
      { q: 'How do I view my revenue reports?', a: 'In the Manager, under Reporting, you find an overview of revenue by day, week or month. You can see your best-selling products, average order values and trends that help you make smarter decisions.' },
      { q: 'Can I adjust opening hours in real time?', a: 'Yes. Close your shop with one click for an unexpected day off, temporarily adjust your peak times or open extra time slots on busy days. Everything instantly, without involving Bistroo.' },
      { q: 'How do I process refunds via the Manager?', a: 'Go to the relevant order in the orders overview and select Refund. The amount is immediately returned to the customer\'s payment account. The average refund rate for Bistroo customers is just 0.2%.' },
      { q: 'Are there push notifications for new orders?', a: 'Yes. The Manager app sends an immediate push notification for every new order. So you never miss an order, even when you are away from the screen.' },
      { q: 'What does the Bistroo Manager cost?', a: 'The Manager app is included in every Bistroo package, including the free plan. You always have full control over your restaurant at no extra cost.' },
    ],
  },
}
